export function normalizeFile(event, maxCount = 1) {
  let files = [];

  if (Array.isArray(event)) {
    files = event;
  } else if (event && Array.isArray(event.fileList)) {
    files = event.fileList;
  }

  if (typeof maxCount === "number" && maxCount !== -1) {
    return files.slice(0, maxCount);
  }

  return files;
}

export function fakeFileUpload({ onSuccess }) {
  onSuccess("ok", null);
}
